import { apiBaseUrl } from "@framework/config/environment";

type BannerEventType = "banner_view" | "banner_click";

/**
 * Fire-and-forget banner analytics. The backend dedupes views per tenant/day
 * and attributes the event to the tenant by domain; failures are ignored.
 */
export function sendMobileAppBannerEvent(
  type: BannerEventType,
  clientId?: number | null,
) {
  if (typeof window === "undefined" || !apiBaseUrl) return;

  const domain = window.location.hostname.toLowerCase().replace(/^www\./, "");
  const body = JSON.stringify({
    type,
    domain,
    ...(clientId ? { clientId } : {}),
  });

  try {
    void fetch(`${String(apiBaseUrl).replace(/\/$/, "")}/mobile/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Analytics must never affect the page.
  }
}
